import { useState, useRef, useEffect } from "react";

export default function OtpInput({
  length = 5,
  onChange,              // (otpString) => void
  autoFocus = true,
  className = ""
}) {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputsRef = useRef([]);

  useEffect(() => {

    onChange?.(otp.join(""));
  }, [otp, onChange]);


  useEffect(() => {
    if (autoFocus && inputsRef.current[0]) inputsRef.current[0].focus();
  }, [autoFocus]);

  const focusInput = (idx) => {
    const el = inputsRef.current[idx];
    if (el) el.focus();
  };

  const setDigit = (idx, digit) => {
    setOtp((prev) => {
      const next = [...prev];
      next[idx] = digit;
      return next;
    });
  };

  const handleSingleInput = (rawVal, idx) => {

    const val = rawVal.replace(/\D/g, "");
    if (!val) {
      setDigit(idx, "");
      return;
    }


    if (val.length === 1) {
      setDigit(idx, val);
      if (idx < length - 1) focusInput(idx + 1);
      return;
    }


    const pasteValues = val.slice(0, length - idx).split("");
    setOtp((prev) => {
      const next = [...prev];
      pasteValues.forEach((v, i) => {
        next[idx + i] = v;
      });
      return next;
    });
    const nextIndex = Math.min(idx + pasteValues.length, length - 1);
    focusInput(nextIndex);
  };

  const handleChange = (e, idx) => {
    handleSingleInput(e.target.value, idx);
  };

  const handleKeyDown = (e, idx) => {
    const key = e.key;

    if (key === "Backspace") {
      if (otp[idx]) {
      
        setDigit(idx, "");
      } else if (idx > 0) {
      
        setDigit(idx - 1, "");
        focusInput(idx - 1);
      }
    }

    if (key === "ArrowLeft" && idx > 0) {
      e.preventDefault();
      focusInput(idx - 1);
    }
    if (key === "ArrowRight" && idx < length - 1) {
      e.preventDefault();
      focusInput(idx + 1);
    }
  };

  const handlePaste = (e, idx) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    const digits = paste.replace(/\D/g, "");
    if (!digits) return;

    const pasteValues = digits.slice(0, length - idx).split("");
    setOtp((prev) => {
      const next = [...prev];
      pasteValues.forEach((v, i) => (next[idx + i] = v));
      return next;
    });
    const nextIndex = Math.min(idx + pasteValues.length, length - 1);
    focusInput(nextIndex);
  };

  return (
    <div dir="ltr" className={`flex justify-center gap-3 w-full max-w-[440px] mx-auto ${className}`}>
      {otp.map((digit, idx) => (
        <input
          key={idx}
          ref={(el) => (inputsRef.current[idx] = el)}
          value={digit}
          onChange={(e) => handleChange(e, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
          onPaste={(e) => handlePaste(e, idx)}
          type="text"
          inputMode="numeric"
          pattern="\d*"
          maxLength={1}
          autoComplete="one-time-code" // برای iOS/Android OTP autofill
          className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 text-center rounded-xl text-xl md:text-2xl border-2 border-gray-400 focus:outline-none focus:ring-2 focus:ring-special transition-colors"
        />
      ))}
    </div>
  );
}
